import { Component, OnInit, Inject, Optional } from '@angular/core';
import { MatDialogRef,MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OpdVisitService } from 'app/opdvisits/Services/OpdVisit.service';

@Component({
  selector: 'app-phoneno_confirmation_dialog',
  templateUrl: './phoneno_confirmation_dialog.component.html',
  styleUrls: ['./phoneno_confirmation_dialog.component.scss']
})
export class Phoneno_confirmation_dialogComponent implements OnInit {
  pdata: any;

  constructor(public dialogRef: MatDialogRef<Phoneno_confirmation_dialogComponent>, @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    public opdvisitService: OpdVisitService) { }

  ngOnInit() {  
   this.pdata=this.data.PhoneData;
  }

  savedetails(){
  
       this.opdvisitService.savepatientdetails();
      
    this.dialogRef.close();
  }

close(){
 // this.dashboardService.popup_cancel = true;
  this.dialogRef.close();
}
}
